import { Grid } from '@mui/material';
import { Outlet } from 'react-router';
import { Snackbars } from '@/components/Snackbar/Snackbar';

export const LayoutSign = () => {
    return (
        <Grid
            container
            sx={theme => ({
                p: '120px 0 100px 0',
                [theme.breakpoints.down('lg')]: {
                    p: '40px 0',
                },
            })}
        >
            <div className="flex flex-wrap w-full justify-center">
                <Outlet />
            </div>
            <Snackbars />
        </Grid>
    );
};
